<ion-select padding-end [(ngModel)]="type" interface="popover"
            [value]="type" placeholder="Select Document Type"
            (ionChange)="setDocType($event)">
    <ion-select-option *ngFor="let type of docTypes">{{type.description}}</ion-select-option>
</ion-select>
